import { Checkbox } from '@eastcoal/formily/components/Checkbox'
import { EditableTable } from '@eastcoal/formily/components/EditableTable'
import { AddButton } from '@eastcoal/formily/components/EditableTable/components/AddButton'
import { RemoveButton } from '@eastcoal/formily/components/EditableTable/components/RemoveButton'
import { TableIndex } from '@eastcoal/formily/components/EditableTable/components/TableIndex'
import { FormGrid } from '@eastcoal/formily/components/FormGrid'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { InputNumber } from '@eastcoal/formily/components/InputNumber'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { GoodsResetButton } from '../components/GoodsResetButton'
import { GoodsTemplateDownloadButton } from '../components/GoodsTemplateDownloadButton'
import { ImportGoodsButton } from '../components/ImportGoodsButton'

export const goodsSchema: Record<string, SchemaItem> = {
  actionRow: {
    type: 'void',
    'x-decorator': FormItem,
    'x-component': FormGrid,
    'x-component-props': {
      maxWidth: 80,
      columnGap: 8,
      strictAutoFit: true
    },
    'x-display': '{{$form.editable ?"visible":"none"}}',
    properties: {
      goodsImportBtn: {
        type: 'void',
        'x-component': ImportGoodsButton
      },
      resetBtn: {
        type: 'void',
        'x-component': GoodsResetButton
      },
      downloadTemplateBtn: {
        type: 'void',
        'x-component': GoodsTemplateDownloadButton
      }
    }
  },
  goods: {
    type: 'array',
    'x-decorator': FormItem,
    'x-component': EditableTable,
    items: [
      {
        name: 'sort',
        type: 'void',
        title: '序号',
        'x-component': TableIndex
      },
      {
        name: 'productName',
        type: 'string',
        title: '标的物',
        required: true,
        'x-decorator': FormItem,
        'x-decorator-props': {
          feedbackLayout: 'popover'
        },
        'x-component': Input
      },
      {
        name: 'specification',
        type: 'string',
        title: '规格/品牌',
        'x-component': Input
      },
      {
        name: 'quantity',
        title: '数量',
        type: 'number',
        'x-component': InputNumber
      },
      {
        name: 'unit',
        type: 'string',
        title: '单位',
        'x-component': Input
      },
      {
        name: 'includeTax',
        type: 'boolean',
        title: '是否含税',
        'x-component': Checkbox
      },
      {
        name: 'remark',
        type: 'string',
        title: '备注',
        'x-component': Input
      },
      {
        name: 'action',
        type: 'void',
        title: <AddButton />,
        'x-display': '{{$form.editable ?"visible":"none"}}',
        'x-component': RemoveButton,
        'x-column-props': {
          align: 'center',
          width: 120
        }
      }
    ]
  }
}
